// Formatador ligado ao idioma da UI e ao fuso do site ativo.
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useActiveContextSnapshot } from '../context/useActiveContext';
import { formatDate, formatDateTime, formatRelative, formatTime, showsZone } from './luxon';

export interface DateFormatter {
  readonly zone: string | null;
  readonly showsZone: boolean;
  readonly dateTime: (value: string | Date) => string;
  readonly date: (value: string | Date) => string;
  readonly time: (value: string | Date) => string;
  readonly relative: (value: string | Date) => string;
}

export function useDateFormatter(): DateFormatter {
  const { i18n } = useTranslation();
  const { timeZoneId } = useActiveContextSnapshot();
  const locale = i18n.resolvedLanguage ?? i18n.language;
  return useMemo(() => {
    const options = { zone: timeZoneId, locale };
    return {
      zone: timeZoneId,
      showsZone: showsZone(timeZoneId),
      dateTime: (value) => formatDateTime(value, options),
      date: (value) => formatDate(value, options),
      time: (value) => formatTime(value, options),
      relative: (value) => formatRelative(value, options),
    };
  }, [timeZoneId, locale]);
}
